export default __webpack_public_path__ + "static/blog-site-9450205f1f29cc338e6b155aa9f732ef.png";